import {
  upQuestionApi,
  collectionTopicList,
  wrongTopicList,
  deleteQuestionApi,
} from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';
import {
  collectionsDeleteApi,
  collectionsPostApi,
  info,
  questionApi,
} from '@/pages/questionBank/subject/service';
import { topicType } from '@@/plugin-dva/connect';

export interface TopicAllType {
  data: topicType[];
  paper_id: string;
  modules: {
    created_at: string;
    id: number;
    title: string;
    chapters: {
      id: string;
      super_id: number;
      title: string;
      papers: {
        id: string;
        paper_id: string;
        title: string;
        desc: string;
        number: number;
        finishCount: number;
        exam_id: number | null;
      }[];
    }[];
  }[];
  userAnswer: [];
  title: string;
  exam_id: number;
  type: number;
}

export interface ModelType {
  namespace: string;
  state: TopicAllType;
  effects: {
    fetch: Effect;
    fetchUserAnswers: Effect;
    fetchWrongQuestion: Effect;
    fetchDelete: Effect;
    fetchQuestion: Effect;
    fetchCollections: Effect;
    fetchDeleteQuestion: Effect;
  };
  reducers: {
    save: Reducer;
    dataChange: Reducer;
    fetchRadioChange: Reducer;
    fetchCheckboxChange: Reducer;
    fetchCheckboxUpAnswer: Reducer;
    saveChange: Reducer;
    defaultData: Reducer;
    collectionChange: Reducer;
    deleteChange: Reducer;
  };
}

const Model: ModelType = {
  namespace: 'topic',

  state: {
    data: [],
    modules: [],
    userAnswer: [],
    title: '',
    exam_id: 0,
    paper_id: '',
    type: 1,
  },

  effects: {
    *fetch({ callback, payload }, { call, put }) {
      const response = yield call(
        payload.type == 2 ? wrongTopicList : collectionTopicList,
        payload,
      );

      if (response && response.error_code === 0) {
        yield put({
          type: 'save',
          payload: {
            ...response,
            type: payload.type,
          },
        });
        if (callback)
          callback({
            ...response,
            type: payload.type,
          });
      }
    },
    *fetchQuestion({ payload }, { call, put }) {
      const response = yield call(questionApi, payload);
      yield put({
        type: 'saveChange',
        payload: {
          ...response,
          index: payload.questionIndex,
        },
      });
    },
    *fetchWrongQuestion({ payload, callback }, { call, put }) {
      const response = yield call(info, payload);
      if (response && response.error_code === 0) {
        let data: string | any[] = [];
        let questionIndex = 0;
        const paper = response.data.paper;

        paper.parts.forEach((item: any) => {
          if (item.question_ids.length > 0) {
            data = data.concat(item.question_ids);
          }
        });

        if (data.length > 0 && response.data.last_question_id) {
          data.forEach((item, index) => {
            if (item.question_id === response.data.last_question_id) {
              questionIndex = index;
            }
          });
        }

        yield put({
          type: 'save',
          payload: {
            ...response,
            questionData: data,
          },
        });
        if (callback)
          callback({
            ...response,
            questionIndex,
          });
      }
    },
    *fetchUserAnswers({ callback, payload }, { call, puy }) {
      const response = yield call(upQuestionApi, payload);
      yield puy({
        type: 'userAnSave',
        payload: response,
      });
    },
    *fetchDelete({ callback, payload }, { call, puy }) {
      const response = yield call(upQuestionApi, payload);
      if (response && response.error_code === 0) {
        yield puy({
          type: 'dataChange',
          payload: payload,
        });
      }
    },
    *fetchCollections({ payload }, { call, put }) {
      const response = yield call(
        payload.isDel ? collectionsDeleteApi : collectionsPostApi,
        payload,
      );
      if (response && response.error_code === 0) {
        yield put({
          type: 'collectionChange',
          payload: {
            ...response,
            index: payload.questionIndex,
            isDel: payload.isDel,
          },
        });
      }
    },
    *fetchDeleteQuestion({ callback, payload }, { call, put }) {
      const response = yield call(deleteQuestionApi, payload);
      if (response && response.error_code === 0) {
        if (callback) callback(response);
        yield put({
          type: 'deleteChange',
          payload: payload,
        });
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data:
          payload.type == 2 ? payload.data.wrongs : payload.data.collections,
        title: payload.data.title,
        paper_id: payload.data.paper_id,
        type: payload.type,
      };
    },
    saveChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index;
      let checked = false;

      checked = !(payload.data.type === 0 || payload.data.type === 1);
      //是否选中答案
      if (state.type == 1) {
        checked = true;
      }
      data[dataIndex - 1] = {
        checked: checked,
        answersChecked: [],
        ...payload.data,
        ...data[dataIndex - 1],
      };
      if (dataIndex - 2 > 0) {
        data[dataIndex - 3] = {
          question_id: data[dataIndex - 3].question_id,
          part_id: data[dataIndex - 3].part_id,
          score: data[dataIndex - 3].score,
          id: data[dataIndex - 3].id,
          record: {
            ...data[dataIndex - 3].record,
          },
          checked: data[dataIndex - 3].checked,
          answersChecked: data[dataIndex - 3].answersChecked,
        };
      }
      if (dataIndex + 2 >= payload.length) {
        data[dataIndex + 2] = {
          question_id: data[dataIndex + 3].question_id,
          part_id: data[dataIndex + 3].part_id,
          score: data[dataIndex + 3].score,
          id: data[dataIndex + 3].id,
          checked: data[dataIndex + 3].checked,
          record: {
            ...data[dataIndex + 3].record,
          },
          answersChecked: data[dataIndex + 3].answersChecked,
        };
      }

      return {
        ...state,
        data: data,
      };
    },
    fetchRadioChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      let arr = [];
      arr.push(payload.answer);
      data[dataIndex] = {
        ...data[dataIndex],
        answersChecked: arr,
        checked: true,
      };
      return {
        ...state,
        data: data,
      };
    },
    fetchCheckboxChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      let answers;
      const indexData = data[dataIndex];
      if (indexData.answersChecked.length > 0) {
        const answersArr = indexData.answersChecked;
        if (answersArr.indexOf(payload.answer) === -1) {
          answers = [...answersArr, payload.answer];
        } else {
          answers = [...answersArr];
        }
      } else {
        answers = [payload.answer];
      }

      data[dataIndex] = {
        ...data[dataIndex],
        answersChecked: answers,
      };
      return {
        ...state,
        data: data,
      };
    },
    fetchCheckboxUpAnswer(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      data[dataIndex] = {
        ...data[dataIndex],
        checked: true,
      };
      return {
        ...state,
        data: data,
      };
    },
    dataChange(state, { payload }) {
      const data = [...state.data];
      data.splice(payload.index, 1);
      return {
        ...state,
        data: data,
      };
    },
    defaultData(state, { payload }) {
      return {
        ...state,
        data: [],
        modules: [],
        userAnswer: [],
        title: '',
        exam_id: 0,
      };
    },
    collectionChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      data[dataIndex].collected = !payload.isDel;
      return {
        ...state,
        data: data,
      };
    },
    deleteChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.questionIndex - 1;
      data.splice(dataIndex, 1);
      return {
        ...state,
        data: data,
      };
    },
  },
};

export default Model;
